/* global window */
import { React, entryPoint, hot, UnstatedProvider } from '@gasbuddy/react';
import { Router } from '../react/common/router';

const App = hot(props => (
  <UnstatedProvider>
    <Router {...props} />
  </UnstatedProvider>
));

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require, import/no-extraneous-dependencies
  require('unstated-debug').logStateChanges = true;
}

const render = () => entryPoint({
  router: App,
  initialState: window.PreloadedState,
});

render();
